import { render, staticRenderFns } from "./CustomFieldType.vue?vue&type=template&id=6f45e94e&"
import script from "./CustomFieldType.vue?vue&type=script&lang=js&"
export * from "./CustomFieldType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports